import { metaKey } from '~/scripts/utils';

export default async ({ $api, route, store }) => {
  await $api(metaKey(route, 'searchPath')).then(r => store.commit('products/setValidations', r));
};
